import { DarwinListView } from 'components/darwin-ui';
import { DataFieldCols } from 'types/dataCaptureTypes';
import { useTranslation } from 'react-i18next';
import { getFieldsColumns } from './columns';
import { SharedTab, BaseTabProps } from '../index';

interface FormCaptureProps
  extends BaseTabProps<{
    form: string;
    formVersion: string;
    userIds?: string[];
  }> {
  captureFields: DataFieldCols[];
  isLoadingFields: boolean;
  showTable: boolean;
  isInitialProcess: boolean;
  onFieldChange: <T extends keyof DataFieldCols>(
    key: string,
    field: T,
    newValue: DataFieldCols[T]
  ) => void;
}

const FormCapture = ({
  form,
  initialValues,
  fields,
  renderInput,
  className,
  onFinish,
  captureFields,
  isLoadingFields,
  showTable,
  isInitialProcess,
  onFieldChange,
}: FormCaptureProps) => {
  const { t } = useTranslation();

  return (
    <SharedTab
      form={form}
      initialValues={initialValues}
      fields={fields}
      renderInput={renderInput}
      className={className}
      onFinish={onFinish}
    >
      <DarwinListView<DataFieldCols>
        data={showTable ? captureFields : []}
        isLoading={showTable && isLoadingFields}
        emptyText={t('process-flow.data-capture.fields-list.empty-text')}
        columns={getFieldsColumns(t, onFieldChange, isInitialProcess)}
        header={{
          title: t('process-flow.data-capture.title'),
        }}
        table={{
          resizable: false,
        }}
      />
    </SharedTab>
  );
};

export default FormCapture;
